/**
 * Strategy Generator API methods
 * @param {Object} api - axios instance
 * @returns {Object} strategy generator API methods
 */
const strategyGeneratorApi = (api) => {
  return {
    /**
     * Extract OCR text from a PDF file
     * @param {File} pdfFile - PDF file to process
     * @returns {Promise} response data containing OCR text
     */
    extractOcrText: async (pdfFile) => {
      try {
        const formData = new FormData();
        formData.append("pdfFile", pdfFile);

        const response = await api.post(
          "/api/StrategyGenerator/ExtractOcrText",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        return response.data;
      } catch (error) {
        // Pass through the exact error message from the API
        if (error.response?.data) {
          // If it's a string message directly
          if (typeof error.response.data === "string") {
            throw new Error(error.response.data);
          }
          // If it has a message property
          else if (error.response.data.message) {
            throw new Error(error.response.data.message);
          }
          // If there's a detailed error
          else if (error.response.data.error) {
            throw new Error(error.response.data.error);
          }
        }
        // Fallback error
        throw error.message ? error : new Error("Failed to extract OCR text");
      }
    },

    /**
     * Test a strategy against OCR text
     * @param {string} ocrText - OCR text to parse
     * @param {string} strategyCode - C# code for the strategy
     * @returns {Promise} response data containing parsed invoice
     */
    testStrategy: async (ocrText, strategyCode) => {
      try {
        const response = await api.post("/api/StrategyGenerator/TestStrategy", {
          ocrText,
          strategyCode,
        });
        return response.data;
      } catch (error) {
        // Pass through the exact error message from the API
        if (error.response?.data) {
          // If it's a string message directly
          if (typeof error.response.data === "string") {
            throw new Error(error.response.data);
          }
          // If it has a message property
          else if (error.response.data.message) {
            throw new Error(error.response.data.message);
          }
          // If there's a detailed error
          else if (error.response.data.error) {
            throw new Error(error.response.data.error);
          }
        }
        // Fallback error
        throw error.message ? error : new Error("Failed to test strategy");
      }
    },

    /**
     * Save a strategy to the server
     * @param {string} strategyName - Name for the strategy
     * @param {string} strategyCode - C# code for the strategy
     * @returns {Promise} response data
     */
    saveStrategy: async (strategyName, strategyCode) => {
      try {
        const response = await api.post("/api/StrategyGenerator/SaveStrategy", {
          strategyName,
          strategyCode,
        });
        return response.data;
      } catch (error) {
        // Pass through the exact error message from the API
        if (error.response?.data) {
          // If it's a string message directly
          if (typeof error.response.data === "string") {
            throw new Error(error.response.data);
          }
          // If it has a message property
          else if (error.response.data.message) {
            throw new Error(error.response.data.message);
          }
          // If there's a detailed error
          else if (error.response.data.error) {
            throw new Error(error.response.data.error);
          }
        }
        // Fallback error
        throw error.message ? error : new Error("Failed to save strategy");
      }
    },
  };
};

export default strategyGeneratorApi;
// /**
//  * Strategy Generator API methods
//  * @param {Object} api - axios instance
//  * @returns {Object} strategy generator API methods
//  */
// const strategyGeneratorApi = (api) => {
//   return {
//     /**
//      * Extract OCR text from a PDF file
//      * @param {File} pdfFile - PDF file to process
//      * @returns {Promise} response data containing OCR text
//      */
//     extractOcrText: async (pdfFile) => {
//       try {
//         const formData = new FormData();
//         formData.append("pdfFile", pdfFile);
//         const response = await api.post(
//           "/api/StrategyGenerator/ExtractOcrText",
//           formData,
//           {
//             headers: {
//               "Content-Type": "multipart/form-data",
//             },
//           }
//         );
//         return response.data;
//       } catch (error) {
//         throw new Error(
//           error.response?.data?.message || "Failed to extract OCR text"
//         );
//       }
//     },

//     /**
//      * Test a strategy against OCR text
//      * @param {string} ocrText - OCR text to parse
//      * @param {string} strategyCode - C# code for the strategy
//      * @returns {Promise} response data containing parsed invoice
//      */
//     testStrategy: async (ocrText, strategyCode) => {
//       try {
//         const response = await api.post("/api/StrategyGenerator/TestStrategy", {
//           ocrText,
//           strategyCode,
//         });
//         return response.data;
//       } catch (error) {
//         throw new Error(
//           error.response?.data?.message || "Failed to test strategy"
//         );
//       }
//     },

//     /**
//      * Save a strategy to the server
//      * @param {string} strategyName - Name for the strategy
//      * @param {string} strategyCode - C# code for the strategy
//      * @returns {Promise} response data
//      */
//     saveStrategy: async (strategyName, strategyCode) => {
//       try {
//         const response = await api.post("/api/StrategyGenerator/SaveStrategy", {
//           strategyName,
//           strategyCode,
//         });
//         return response.data;
//       } catch (error) {
//         throw new Error(
//           error.response?.data?.message || "Failed to save strategy"
//         );
//       }
//     },
//   };
// };

// export default strategyGeneratorApi;
